export enum CookVerificationStatus {
    INITIATED= "INITIATED",
    REPORT_GENERATED = "REPORT_GENERATED",
    INSUFFICIENT_DETAILS= "INSUFFICIENT_DETAILS",
    FAILED= "FAILED"
}